import { render, staticRenderFns } from "./CollectionNavigation.vue?vue&type=template&id=7e01b850&"
import script from "./CollectionNavigation.vue?vue&type=script&lang=js&"
export * from "./CollectionNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports